import React from "react";
import Clients from "./Clients";
import { Link } from "react-router";
import { Row, Col } from "react-bootstrap";
import Image from 'react-bootstrap/Image';

import { GiCheckMark } from "react-icons/gi";

import heroImage from "../../Assets/k5YdmwpLXOHfDCXNgsm0yN9Gdxg.avif"
import aboutImage from "../../Assets/1662929345-about.avif"
import talent1 from "../../Assets/talent1.jpeg"
import talent2 from "../../Assets/talent2.jpeg"
import talent3 from "../../Assets/talent3.jpeg"
import talent4 from "../../Assets/talent4.jpeg"
import talent5 from "../../Assets/talent5.jpeg"

import './HomeStyle.css';

function Home() {
    return (
        <div>
            <section className="home-section mx-3">
                <div className="heroFramer p-5 d-flex flex-column justify-content-between">
                    <h1 className="text-white pt-5 fw-bold">Accelerate Talent. Power Global Growth.<br />Compliant IT & Non-IT Staffing for Global Enterprises
                    </h1>
                    <div>
                        <Link to="/service" className="btn btn-light w-auto">Read more
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="rgb(12, 20, 26)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg></Link>
                    </div>
                </div >
                <Image src={heroImage} className="heroImage" />
            </section >
            <Clients />
            <section className="">
                <div className='p-5'>
                    <div className="layout-halfs_wrap is-main">
                        <div className="layout-halfs_content">
                            <Image src={aboutImage} className="img-fluid rounded" />
                        </div>
                        <div className="layout-halfs_content pt-3 pb-md-0">
                            <h1 className="pb-0 pb-md-3">Who We Are</h1>
                            <p className="text-size-large">We are a trusted staffing partner for global organizations, delivering end-to-end compliant workforce solutions across IT and Non-IT domains. Whether you’re scaling rapidly, hiring niche talent, or managing high-volume workforce needs, we help you build teams that perform—fast, reliably, and compliantly.</p>
                            <small className="text-size-medium">With a deep understanding of global workforce dynamics, we act as an extension of your talent team—focused on quality, continuity, and long-term success.</small>
                            <Link to="/about" className="btn btn-dark w-auto mt-0 mt-md-5 text-uppercase">
                                more about us
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="rgb(255, 255, 255)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
            <section className='padding-section-large bg-dark text-white px-5'>
                <Row className='mb-4 w-75'>
                    <h1 className='pb-0 pb-md-5'>The CeWaves Advantage: <br />Your Strategic Partner in Talent</h1>
                </Row>
                <div className="d-md-flex gap-4 pt-3 text-dark">
                    <div className="col bg-white shadow-sm gap-2 border rounded p-3 mb-5 mb-md-0">
                        <Image src={talent1} className="w-auto h-25 pb-3" />
                        <h4>Deep Talent Pool</h4>
                        <p className="text-size-medium">Fast access to a large, diverse talent pool across IT and Non-IT domains for rapid onboarding.</p>
                    </div>
                    <div className="col bg-white shadow-sm gap-2 border rounded p-3 mb-5 mb-md-0">
                        <Image src={talent2} className="w-auto h-25 pb-3" />
                        <h4>Dedicated Teams</h4>
                        <p className="text-size-medium">Personalized service from dedicated hiring teams that understand enterprise needs and processes.</p>
                    </div>
                    <div className="col bg-white shadow-sm gap-2 border rounded p-3 mb-5 mb-md-0">
                        <Image src={talent3} className="w-auto h-25 pb-3" />
                        <h4>Enterprise Expertise</h4>
                        <p className="text-size-medium">Proven, industry-specific expertise for sourcing complex and highly specialized roles.</p>
                    </div>
                    <div className="col bg-white shadow-sm gap-2 border rounded p-3 mb-5 mb-md-0">
                        <Image src={talent4} className="w-auto h-25 pb-3" />
                        <h4>Scalable & Cost-Effective</h4>
                        <p className="text-size-medium">Flexible staffing models aligned to your evolving business needs and budget realities.</p>
                    </div>
                    <div className="col bg-white shadow-sm gap-2 border rounded p-3">
                        <Image src={talent5} className="w-auto h-25 pb-3" />
                        <h4>Compliance-First Focus</h4>
                        <p className="text-size-medium">A trusted partner for procurement and vendor managers, prioritizing reliability, flexibility, and seamless, compliant onboarding.</p>
                    </div>
                </div>
            </section>
            <section className='padding-section-large px-5'>
                <Row className='mb-4'>
                    <h1 className=''>A Partnership Built for Long-Term<br />Workforce Stability and Success</h1>
                    <p className="text-size-large pt-3">Beyond transactional staffing, CeWaves provides a strategic framework for acquiring and managing talent.</p>
                    <ul className="list-unstyled pt-3 text-size-large">
                        <li className="pb-3"><span className="pe-2"><GiCheckMark style={{ "color": "#1dbc3fff" }} /></span>One Partner, Total Clarity: Simplify your vendor landscape and gain a holistic view of your contingent and permanent workforce.</li>
                        <li className="pb-3"><span className="pe-2"><GiCheckMark style={{ "color": "#1dbc3fff" }} /></span>Compliance at the Core: Align with a partner that prioritizes your compliance and oversight
                            requirements from day one.</li>
                        <li className="pb-3"><span className="pe-2"><GiCheckMark style={{ "color": "#1dbc3fff" }} /></span>Customized for You: Our dedicated teams deliver customized processes that align with your specific recruitment and onboarding needs.</li>
                    </ul>
                </Row>
            </section>
        </div >
    );
}

export default Home;